<template>
  <div class="containerTable" style="padding:20px;">
    <vxe-toolbar
      id="toolbarId_bc17"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('vehicle_search_button')" @click="funcFilter"
          >查询</el-button
        >
        <el-button v-if="getLimit('vehicle_export_button')" @click="funcExport"
          >导出</el-button
        >
        <el-button
          v-if="getLimit('vehicle_registerVehicle_button')"
          @click="funcRecord"
          >批量备案</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      height="80%"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="驾驶员姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入驾驶员姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车辆牌照号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车辆牌照号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationCode"
          title="车辆分类"
          :formatter="formatterVehicleClassification"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 总质量 -->
      <vxe-table-column>
        <vxe-table-column
          field="totalWeight"
          title="总质量/挂车车头整备质量(kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 装卸质量 -->
      <vxe-table-column>
        <vxe-table-column
          field="loadWeight"
          title="核定载质量/准牵引总质量(kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadStatus"
          title="载重状态"
          :formatter="formatterLoadStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.loadStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in loadStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="driverIsFreezeExt"
          title="是否冻结"
          :formatter="formatterIsFreeze"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.driverIsFreezeExt" placeholder="请选择" clearable>
            <el-option
              v-for="item in isFreezeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="etcStatusExt"
          title="是否备案"
          :formatter="
            ({ cellValue }) => formatterOptions(cellValue, 'etcStatusExt')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.etcStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in etcStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="locationSource"
          title="定位来源"
          :formatter="formatterLocationSource"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.locationSource"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in locationSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          v-if="isCtms"
          field="netStatus"
          :formatter="formatterNetStatus"
          title="车辆入网"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.netStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in netStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('vehicle_detail_button')"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code, scope.row.partyCode)"
            >
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('vehicle_vehicleTrail_button')"
            effect="dark"
            content="车辆定位"
            placement="top"
          >
            <vxe-button type="text" @click="funcVehicleTrail(scope.row.code)">
              <em class="el-icon-location-information" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('vehicle_registerVehicle_button') &&
                scope.row.authStatusExt == 3
            "
            effect="dark"
            content="车辆备案"
            placement="top"
          >
            <vxe-button type="text" @click="registerVehicle(scope.row)">
              <em class="el-icon-folder-add" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1400"
      height="800"
      resize
    >
      <compDetail
        ref="detailRef"
        :parent-data="{
          isDetail,
          vehicleClassificationList,
          vehicleLengthList,
          vehicleWidthList,
          vehicleHighList,
          vehicleTonnageList,
          locationSourceList,
          vehicleLicenseColorList,
          vehicleEnergyTypeList
        }"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelVehicleTrailFlag"
      title="车辆定位"
      width="900"
      height="80%"
      resize
    >
      <compVehicleTrail ref="vehicleTrailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="Printingxianyin"
      title="打印"
      width="900"
      height="80%"
      resize
    >
      <Printinging ref="dayinRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/vehicleDetail.vue";
import Printinging from "./components/Printing.vue";
import compVehicleTrail from "./components/vehicleTrail.vue";
import { vehicle } from "@/api/transport";
import {
  freezeDriver,
  unfreezeTeamDriver,
  registerVehicle,
  registerVehicles
} from "@/api/driver";
import { getListDict } from "@/api/commonApi";
import { getRole } from "@/utils/getRole";
export default {
  name: "PlatVehicle",
  components: {
    compDetail,
    compVehicleTrail,
    Printinging
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicle/exportVehicleList", //导出接口
        name: "平台车辆"
      },
      isCtms: true, //默认显示  同城系统隐藏
      Printingxianyin: false,
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      modelVehicleTrailFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        branchCodeExt: "",
        code: "",
        licenseNumber: "",
        driverPhone: "",
        branchCode: "",
        teamCode: "",
        licensePlateType: "",
        classificationCode: "",
        roadTransportCertificateNumber: "",
        roadTransportCertificateImg: "",
        roadTransportCertificateDate: "",
        loadWeight: "",
        loadVolume: "",
        remainingLoadWeight: "",
        remainingLoadVolume: "",
        vehicleLicenseColor: "",
        vehicleLicenseImg: "",
        vehicleLicenseDueDate: "",
        vehicleImg: "",
        isHasTrailer: "",
        trailerNum: "",
        trailerVehicleLicenseImg: "",
        trailerRoadTransport: "",
        trailerRoadTransportCertificateImg: "",
        trailerVehicleImg: "",
        authStatus: "",
        authStatusExt: "",
        loadStatus: "",
        isFreeze: "",
        locationSource: "",
        terminalNumber: "",
        driverIsFreeze: "",
        driverIsFreezeExt: "",
        etcStatusExt: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      isDetail: true,
      vehicleClassificationList: [],
      vehicleLengthList: [],
      vehicleWidthList: [],
      vehicleHighList: [],
      vehicleTonnageList: [],
      locationSourceList: [],
      vehicleEnergyTypeList: [],
      vehicleLicenseColorList: [],
      // 载重状态
      loadStatusOptions: [
        {
          label: "空载",
          value: 0
        },
        {
          label: "负载",
          value: 1
        }
      ],
      // 审核状态
      authStatusOptions: [
        {
          label: "未审核",
          value: 0
        },
        // { label: "审核中", value: 1 },
        {
          label: "审核驳回",
          value: 2
        },
        {
          label: "审核通过",
          value: 3
        }
      ],
      // 是否冻结
      isFreezeOptions: [
        {
          label: "未冻结",
          value: 0
        },
        {
          label: "已冻结",
          value: 1
        }
      ],
      // 是否冻结
      etcStatusExtOptions: [
        {
          label: "否",
          value: "0"
        },
        {
          label: "是",
          value: "1"
        }
      ],
      // 是否入网
      netStatusOptions: [
        {
          label: "未入网",
          value: 0
        },
        {
          label: "已入网",
          value: 1
        }
      ]
    };
  },
  created() {
    // 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源，车牌颜色
    getListDict({
      types:
        "vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor"
    }).then(response => {
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.vehicleLengthList = response.data.filter(
        item => item.type === "vehicleLength"
      )[0]["dictList"];
      this.vehicleWidthList = response.data.filter(
        item => item.type === "vehicleWidth"
      )[0]["dictList"];
      this.vehicleHighList = response.data.filter(
        item => item.type === "vehicleHigh"
      )[0]["dictList"];
      this.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      this.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
      this.findList();
    });
    this.isCtms = !getRole();
    this.listQuery.branchCodeExt = JSON.parse(
      localStorage.getItem("dataBranch")
    ).code;
  },
  methods: {
    // 编辑
    funcEdit(code, partyCode) {
      this.$router.push({
        path: "/basicInfo/driver/editDriverCarForm",
        query: { code, partyCode, isDetail: 0 }
      });
    },
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ""));
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        vehicle(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 批量上传
    funcBatchUp() {
      this.checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!this.checkedRowArray || this.checkedRowArray.length === 0) {
        this.$message({
          message: "请选择要上传的车辆",
          type: "warning"
        });
      } else {
        this.$message({
          message: "上传成功",
          type: "success"
        });
        // const checkCodeArray = []
        // this.checkedRowArray.forEach(item => {
        //   checkCodeArray.push(item.partyCode)
        // })
        // const checkPartyCodes = checkCodeArray.join(',')
        // request({ url: '/ntocc-tms-api/', method: 'post', params: { teamCodes: checkPartyCodes }}).then(response => {
        //   this.$message({ message: '上传成功', type: 'success' })
        //   this.findList()
        // })
      }
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    //打印
    Printing(code, licenseNumber) {
      this.$refs.dayinRef.getInfo(code, licenseNumber);
      this.Printingxianyin = true;
    },
    // 车辆历史跟踪方法
    funcVehicleTrail(code) {
      this.$refs.vehicleTrailRef.trajectory(code);
      this.modelVehicleTrailFlag = true;
    },
    // 冻结
    lockCar(row) {
      this.$confirm("确认冻结吗？")
        .then(_ => {
          freezeDriver({
            partyCode: row.partyCode
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 解除冻结
    unlockCar(row) {
      this.$confirm("确认解除冻结吗？")
        .then(_ => {
          unfreezeTeamDriver({
            partyCode: row.partyCode
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.vehicleClassificationList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    // 翻译载重状态
    formatterLoadStatus({ cellValue }) {
      const item = this.loadStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译是否冻结
    formatterIsFreeze({ cellValue }) {
      const item = this.isFreezeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译定位来源
    formatterLocationSource({ cellValue }) {
      const item = this.locationSourceList.find(item => item.code == cellValue);
      return item ? item.name : "";
    },
    // 翻译是否入网
    formatterNetStatus({ cellValue }) {
      const item = this.netStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译
    formatterOptions(cellValue, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value == cellValue
      );
      return item ? item.label : "";
    },
    //车辆备案
    registerVehicle(row) {
      this.$confirm("确认备案该车辆（ETC）？")
        .then(_ => {
          registerVehicle({
            num: row.licenseNumber
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funcRecord() {
      let selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length == 0) {
        this.$message({
          message: "请选择备案车辆!",
          type: "warning"
        });
        return false;
      }
      for (let i = 0; i < selectRecords.length; i++) {
        // if (selectRecords[i].etcStatusExt == 1) {
        // 	this.$message({
        // 		message: '所选车辆包含已备案车辆，请重新选择!',
        // 		type: 'warning'
        // 	})
        // 	return false;
        // }
        if (selectRecords[i].authStatusExt != 3) {
          this.$message({
            message: "所选车辆包含未审核通过车辆，请重新选择!",
            type: "warning"
          });
          return false;
        }
      }
      const rLoading = this.openLoading();
      let vehicleNum = selectRecords.map(item => item.licenseNumber).join(",");
      registerVehicles({
        nums: vehicleNum
      }).then(response => {
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.findList();
        rLoading.close();
      });
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    }
  }
};
</script>
